import React from 'react'
//Helpers
import { RealEstateDataPageComponentData } from 'types'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { getPhotos } from '@helpers/helper.rendering'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const JumbotronDevelopment_1 = ({ developmentID, global_data }: CombinedProps) => {
  const { data: allDevelopmentData, isLoading } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  function asignarTextoALasImagenes() {
    const descriptionFragments = allDevelopmentData?.description.split('. ')

    const result: { image: string; description: string }[] = []
    let currentPhotoIndex = 0
    let currentDescription = ''

    for (let i = 0; i < descriptionFragments?.length; i++) {
      const nextFragment = descriptionFragments[i]
      const potentialText =
        currentDescription !== '' ? `${currentDescription}. ${nextFragment}` : nextFragment

      if (potentialText.length <= 600) {
        currentDescription =
          currentDescription !== '' ? `${currentDescription}. ${nextFragment}` : nextFragment
      } else {
        if (currentDescription !== '') {
          if (getPhotos(allDevelopmentData?.photos)[currentPhotoIndex].is_front_cover === false) {
            result.push({
              image: getPhotos(allDevelopmentData?.photos)[currentPhotoIndex]?.image,
              description: currentDescription + '.',
            })
          }
          currentPhotoIndex++
        }
        currentDescription = nextFragment
      }
    }

    // Agregar la última descripción si es menor o igual a 200 caracteres y hay imágenes disponibles
    if (
      currentDescription !== '' &&
      currentPhotoIndex < getPhotos(allDevelopmentData?.photos).length
    ) {
      result.push({
        image: getPhotos(allDevelopmentData?.photos)[currentPhotoIndex]?.image,
        description: currentDescription + '.',
      })
    }

    return result
  }

  return (
    <section className="p-y-config development-grid a">
      {isLoading &&
        [1, 2].map((index) => (
          <div
            key={index}
            className={'d-flex div-item ' + (index % 2 === 1 && ' float-right ')}
          >
            <div className="div-text skeleton skeleton-opacity d-flex align-items-center justify-content-center">
              <p>{}</p>
            </div>
            <div className="skeleton div-image"></div>
          </div>
        ))}
      {asignarTextoALasImagenes().map(({ description, image }, index) => (
        <div
          key={index}
          className={'d-flex div-item ' + (index % 2 === 1 && ' float-right ')}
        >
          <div className="div-text d-flex align-items-center justify-content-center">
            <p>{description}</p>
          </div>
          <div className="div-image">
            <img
              src={image}
              alt=""
            />
          </div>
        </div>
      ))}
    </section>
  )
}

export default JumbotronDevelopment_1
